import axios from "axios";
import { BASE_URL } from "./url";
import { withCache } from "../utils/apiCache";

const loginAxios = axios.create({
    withCredentials: true,
    baseURL: BASE_URL,
});

export const getWebcalls = async () =>
    withCache("webcalls/list", async () => {
        try {
            const result = await loginAxios.get(`/webcalls`);
            return result?.data;
        } catch (e) {
            console.log(e);
            return { ok: false, ...e?.response?.data };
        }
    });

export const getCallDataById = async (callId) =>
    withCache(`webcalls/detail/${callId}`, async () => {
        try {
            const response = await loginAxios.get(`/webcalls/details/${callId}`);
            return response.data;
        } catch (e) {
            console.log(e);
            return { ok: false, ...e?.response?.data };
        }
    });

export const getEmailConversations = async () =>
    withCache("webcalls/emails", async () => {
        try {
            const response = await loginAxios.get(`/webcalls/emails`);
            return response.data;
        } catch (e) {
            console.log(e);
            return { ok: false, ...e?.response?.data };
        }
    });
